import { Box } from '@wishket/design-system';

import { TooltipButton, TooltipIconButton } from './ArticleRowToolbar.parts';

import { ArticleToolbarProps } from '@/shared/types';

const ArticleRowToolbar = ({
  like,
  isLiked,
  comment,
  isScrapped,
  scrapButtonId,
  onLikeClick,
  onCommentClick,
  onScrapClick,
  onShareClick,
}: ArticleToolbarProps) => {
  return (
    <Box className="flex w-full justify-between">
      <Box className="flex gap-5">
        <TooltipButton
          text="좋아요"
          count={like}
          icon="large_like"
          onClick={onLikeClick}
          isTriggered={isLiked}
        />
        <TooltipButton
          text="댓글"
          count={comment}
          icon="large_bubble"
          onClick={onCommentClick}
        />
      </Box>
      <Box className="flex items-center">
        <TooltipIconButton
          id={scrapButtonId}
          text={isScrapped ? '스크랩 됨' : '스크랩'}
          icon="large_scrap"
          onClick={onScrapClick}
          isTriggered={isScrapped}
        />
        <TooltipIconButton
          text="공유"
          icon="large_share"
          onClick={onShareClick}
        />
      </Box>
    </Box>
  );
};

export default ArticleRowToolbar;
